export enum DESCRIPTION_TYPE {
    General = "general"
}
